import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { StoreState } from '../../models/store.interface';
import { CityService } from './city.service';

const service = new CityService();

export interface CityState {
   radiusOptions: Array<{ value: number; label: string }>;
}

const CityStore: Module<CityState, StoreState> = {
   namespaced: true,
   state: {
      radiusOptions: [...Array(20)].map((_, index) => {
         const range = index * 5 + 5;
         return { value: range, label: `< ${range} km` };
      }),
   },
   getters: {},
   mutations: {},
   actions: {
      async searchCities(context, query: LocationQuery) {
         const cities = await service.getCities(query);
         return cities;
      },
   },
};

export default CityStore;
